const menuStore = {
	state: {
		routers: [],
	},

	mutations: {
		SET_ROUTERS: (state, routers) => {
			state.routers = routers;
		}
	},

	actions: {
		setRouterToStore({ commit }, routers){
			commit('SET_ROUTERS', routers)
		}
	}
};

export default menuStore;



// WEBPACK FOOTER //
// ./src/store/modules/menuStore.js